import Ajv from 'ajv';
import addFormats from 'ajv-formats';

const ajv = addFormats(new Ajv());

export default ajv;
export const getValidationErrors = () => ajv.errors;
